import { AbstractShape } from "../abstract/Shape";
import { Connection } from "./Connection";

export class ViewsCanvas{
    constructor(public view: AbstractShape[], public conections: Connection[], public sentence: string, public uuid: string, public model_UUID?: string, public hierarchy?: string){}
}